export const enableSticky = (
  stickySideBoxRef: any,
  stickyWrapperRef: any,
  stickyTopOffset: any,
  stickyBottomOffset: any
) => {
  window.addEventListener('scroll', () => {
    const sideBoxHeight = stickySideBoxRef?.current?.clientHeight || 0;
    const sideBoxWidth = stickySideBoxRef?.current?.clientWidth || 0;
    const stickyBoxRect = stickyWrapperRef?.current?.getBoundingClientRect() || null;

    if (
      stickySideBoxRef &&
      stickySideBoxRef.current &&
      stickyBoxRect &&
      stickyBoxRect.top - stickyTopOffset < 0 &&
      stickyBoxRect.bottom - (sideBoxHeight + stickyBottomOffset + 90) > 0
    ) {
      //inRange
      stickySideBoxRef.current.style.position = 'fixed';
      stickySideBoxRef.current.style.width = sideBoxWidth + 'px';
      stickySideBoxRef.current.style.top = stickyTopOffset + 'px';
    } else if (
      stickyBoxRect &&
      stickySideBoxRef.current &&
      stickyBoxRect.top > 0 &&
      stickyBoxRect.bottom > 0
    ) {
      //onTopOfRange
      stickySideBoxRef.current.style.position = 'relative';
      stickySideBoxRef.current.style.width = '100%';
      stickySideBoxRef.current.style.top = '0px';
    } else if (stickyBoxRect && stickySideBoxRef.current) {
      //underRange
      stickySideBoxRef.current.style.position = 'relative';
      stickySideBoxRef.current.style.width = '100%';
      stickySideBoxRef.current.style.top =
        stickyBoxRect?.height - (sideBoxHeight + stickyBottomOffset) + 'px';
    }
  });
};
